import harnessImage from "../../assets/images/harness.png";

function ItemsOrderedCard({ order }) {

  const items = order?.items || [];
const subtotal = Number(order?.subtotal || 0);
const tax = Number(order?.tax || 0);
const shipping = Number(order?.shipping || 0);
const total = Number(order?.total || 0);

  return (
    <div style={styles.card}>

      <div style={styles.title}>Items Ordered</div>

      <div style={styles.layout}>

        {/* LEFT SIDE — ITEMS */}
        <div>

          <div style={styles.headerRow}>
            <div></div>
            <div>Item</div>
            <div>Qty</div>
            <div>Price</div>
          </div>

          {items.length === 0 ? (
            <div style={styles.empty}>No items found on this order.</div>
          ) : (
            items.map((item, index) => {

              const numericPrice = Number(item.price || 0);
              const qty = Number(item.qty || 1);
              const lineTotal = numericPrice * qty;

              return (
                <div style={styles.itemRow} key={item._id || index}>

                  <img
                  src={
  item.image
    ? item.image.startsWith("http")
      ? item.image
      : `${item.image.replace(/^\/+/, "")}`
    : harnessImage
}
                    alt={item.title || "Part"}
                    style={styles.image}
                  />

                  <div style={styles.name}>
                    {item.title || "Unknown Part"}
                    {item.subtitle && (
                      <>
                        <br />
                        <span style={styles.subtitle}>{item.subtitle}</span>
                      </>
                    )}
                  </div>

                  <div style={styles.qty}>x{qty}</div>

                  <div style={styles.price}>${lineTotal.toFixed(2)}</div>

                </div>
              );
            })
          )}

        </div>

        {/* RIGHT SIDE — TOTALS */}
        <div style={styles.totals}>

          <div style={styles.totalRow}>
            <span>Subtotal</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>

          <div style={styles.totalRow}>
            <span>Shipping</span>
          <span>
  {shipping === 0
    ? <span style={styles.free}>Free</span>
    : `$${shipping.toFixed(2)}`
  }
</span>
          </div>

<div style={styles.totalRow}>
            <span>Estimated Tax</span>
            <span>${tax.toFixed(2)}</span>
          </div>

          {Number(order?.appliedCredit) > 0 && (
            <div style={{ ...styles.totalRow, color: "#10b981", fontWeight: 600 }}>
              <span>Store Credit Applied</span>
              <span>−${Number(order.appliedCredit).toFixed(2)}</span>
            </div>
          )}

          <div style={styles.totalDivider} />

          <div style={styles.totalFinal}>
            <span>Total</span>
            <span>${total.toFixed(2)}</span>
          </div>

        </div>

      </div>

    </div>
  );
}

export default ItemsOrderedCard;

const styles = {

  card: {
    padding: 30,
    borderRadius: 22,
    background: "linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",
    border: "2px solid #ffffff",
    boxShadow:
      "0 0 30px rgba(120,170,255,0.18), \
       0 20px 50px rgba(0,0,0,0.10), \
       0 6px 18px rgba(0,0,0,0.06), \
       inset 0 1px 0 rgba(255,255,255,1)"
  },

  title: {
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 20,
    color: "#1D1D1F"
  },

  headerRow: {
    display: "grid",
    gridTemplateColumns: "70px 1fr 80px 120px",
    fontSize: 13,
    color: "#8E8E93",
    marginBottom: 16,
    gap: 16
  },

  itemRow: {
    display: "grid",
    gridTemplateColumns: "70px 1fr 80px 120px",
    alignItems: "center",
    gap: 16,
    padding: "14px 0",
    borderTop: "1px solid rgba(0,0,0,0.06)"
  },

  image: {
    width: 56,
    height: 56,
    objectFit: "contain",
    borderRadius: 12,
    background: "#ffffff",
    padding: 6,
    boxShadow: "0 6px 12px rgba(0,0,0,0.06)"
  },

  name: {
    fontSize: 15,
    lineHeight: "20px",
    color: "#1D1D1F",
    fontWeight: 500
  },

  subtitle: {
    fontSize: 13,
    color: "#8E8E93",
    fontWeight: 400
  },

  qty: {
    fontSize: 15,
    color: "#1D1D1F"
  },

  price: {
    fontSize: 16,
    fontWeight: 600,
    color: "#1D1D1F"
  },

  empty: {
    fontSize: 15,
    color: "#8E8E93",
    padding: "20px 0"
  },

  layout: {
    display: "grid",
    gridTemplateColumns: "1fr 320px",
    gap: 40
  },

  totals: {
    paddingTop: 48,
    paddingLeft: 32,
    borderLeft: "1px solid rgba(0,0,0,0.06)"
  },

  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 15,
    color: "#1D1D1F",
    marginBottom: 10
  },

  totalDivider: {
    height: 1,
    margin: "18px 0",
    background: "linear-gradient(to right, transparent, #e3e3e8, transparent)"
  },

  totalFinal: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 22,
    fontWeight: 600,
    color: "#1D1D1F"
  },

  free: {
    color: "#2D6CFF",
    fontWeight: 600
  }

};